import React from 'react';
import associaImmagineENomeANomeUtente from '../funzioniComuni/associaImmagineENomeANomeUtente';

function HomeNuovoUtente({ autenticazione }) {

    const { pathImmagine, nomeDisplay } = associaImmagineENomeANomeUtente(autenticazione.username, autenticazione.username)

    return (
        <div className='colonnaTuttaPagina flex justify-center mt4 pa4'>
            <div className='w-50 h-75 pa5 tc sfondoBiancoTema br4'>
                <img
                    src={pathImmagine}
                    className="br-100 h3 mb3"
                    alt="foto utente"></img>
                <div className='f4 b mt3 mb2 tl'>Ciao {autenticazione.nickname} !</div>
                <div className='f5 tl'><span>Se vedi questa pagina è perché non esistevi fino ad adesso e ti devono assegnare i permessi per accedere alle aree qui sopra. Scrivi a Damiano se non sa che deve farlo. Intanto se hai piacere puoi impostare la tua immagine profilo su </span>
                    <a href='https://wordpress.com/log-in/link?client_id=1854&redirect_to=https%3A%2F%2Fpublic-api.wordpress.com%2Foauth2%2Fauthorize%3Fclient_id%3D1854%26response_type%3Dcode%26blog_id%3D0%26state%3D8bc0afeed0e7bfa1946c565f164c37da0418ffd965fd87db201637031466f336%26redirect_uri%3Dhttps%253A%252F%252Fgravatar.com%252Fconnect%252F%253Faction%253Drequest_access_token%26from-calypso%3D1' target="_blank" rel="noopener noreferrer">Gravatar</a> registrandoti con la stessa mail che hai usato qui (se hai usato Google, usa la tua mail di Google)
                    <div className='f6 mt4 tl'>Per smettere di vedere questa pagina scegli una homepage in "impostazioni"</div>
                </div>
            </div>
        </div>
    )
}

export default HomeNuovoUtente;